import { getRequestData, emptyObj } from '@/utils';
import { createCustomerBsnl } from '@/pages/NewConnection/services';

export default {
  namespace: 'transferCustomer',
  state: {
    attrObj: {},
    POICertTypeList: [],
    POACertTypeList: [],
    stateAddrOpts: [],
    districtOpts: [],
    mainLocalityOpts: [],
    subLocalityOpts: [],
    occupationList: [],
    custAddressId: '',
    custValueMap: {}, // 已存在客户的相关信息
    custCertValue: {}, // 已存在客户证件信息
    custContactMan: {}, // 已存在客户联系人信息
    custAddrList: [], // 已存在客户地址信息
    custAddrInfo: {},
    poaDefaultFileList: [],
    poiDefaultFileList: [],
    customerInfo: {},
    searchCustInfo: {}, // 搜索出来的用户信息
    searchFormValue: {}, // 搜索表单初始值用于复显
    newCustomerInfo: {}, // 过户的用户详情用于review
    newInstallationAddress: {}, // 过户的安装地址用于review
    accountInfo: {}, // 过户的帐户详情用于review
  },
  effects: {
    *createCustomerBsnl({ payload }, { call, put }) {
      const createCustResponse = yield call(createCustomerBsnl, payload);
      const { custCode, custId } = getRequestData(createCustResponse);
      yield put({
        type: 'save',
        payload: { custId, custCode },
      });
      return { custCode, custId };
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    clear(state) {
      return emptyObj(state);
    },
  },
};
